export class InvoiceInformationBDC {
    public libelle: string | null;
    public montantHT: string | null;
  }